import Auth from '@Services/Auth';
import { StructureEditorsConst } from '@Pages/StructureEditor/StructureEditorConstants';
import find from 'lodash/find';
import get from 'lodash/get';
import values from 'lodash/values';

export const getDefaultEditor = () => {
  // eslint-disable-next-line no-use-before-define
  const editors = getAvailableEditors();
  const currentUser = Auth.getUser();
  const editorSetting = get(currentUser, 'details.settings.structureEditorPreselected');
  let editor = values(editors)[0];
  editor = find(editors, { setting: editorSetting }) || editor;
  return editor && editor.name;
};

export const getCurrentEditor = () => {
  const currentUser = Auth.getUser();
  return get(currentUser, 'structureEditor.current') || getDefaultEditor();
};

export const setCurrentEditor = (name) => {
  const currentUser = Auth.getUser();
  const structureEditor = get(currentUser, 'structureEditor', {});
  structureEditor.current = name;
  Auth.updateUser({
    structureEditor,
  });
};

export const getAvailableEditors = () => StructureEditorsConst;
